import { render, staticRenderFns } from "./guestList.vue?vue&type=template&id=2d22a2d4&scoped=true&"
import script from "./guestList.vue?vue&type=script&lang=js&"
export * from "./guestList.vue?vue&type=script&lang=js&"
import style0 from "./guestList.vue?vue&type=style&index=0&id=2d22a2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22a2d4",
  null
  
)

export default component.exports